import {ApiClient} from '@hconnect/apiclient'
import {type Iso8601} from '@hconnect/common/types'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import {KpisQueryKey, type KpiQualityDto} from '../../types'

type Params = {
  plantId: string
  from?: Iso8601
  to?: Iso8601
}

const QueryKeyPrefix = KpisQueryKey.MaterialQualityKpis

export const useMaterialQualityKpis = (
  {plantId, from, to}: Params,
  options?: Omit<UseQueryOptions<KpiQualityDto, AxiosError>, 'queryKey' | 'queryFn'>
) => {
  return useQuery<KpiQualityDto, AxiosError>({
    queryKey: [QueryKeyPrefix, plantId, from, to],
    queryFn: async ({signal}) => {
      const path = `/kpi-result/${plantId}/quality-kpis`
      const response = await ApiClient.axiosInstance.get<KpiQualityDto>(path, {
        params: {from, to},
        signal
      })
      return response.data
    },
    ...options
  })
}
